<template>
  <BaseCard class="job-card shadow-flat-strong">
    <div class="job-card__row job-card__row--location">
      <p class="job-card__label">Location</p>
      <div class="job-card__value">
        {{ location }}
        <BaseTooltip :placement="'bottom-end'">
          <template #label>
            <div class="job-card__icon" />
          </template>
          <template #content>
            <p v-if="data.country_id" class="job-card__tooltip-location">
              {{ data.country_id }}
            </p>
            <p class="job-card__tooltip">
              Infermedica is a remote-first company. So why do you see a
              particular location here? To boost the outreach, we advertise our
              jobs on external job boards that require us to specify the
              location.
            </p>
            <p class="job-card__tooltip">
              Nevertheless, nothing has changed; we are and will remain
              remote-first.
            </p>
          </template>
        </BaseTooltip>
      </div>
    </div>
    <div v-if="data.type" class="job-card__row">
      <p class="job-card__label">Commitment</p>
      <p class="job-card__value">
        {{ data.type }}
      </p>
    </div>
    <div v-if="data.minimum_salary" class="job-card__row">
      <p class="job-card__label">Salary</p>
      <p class="job-card__value">
        {{ formatSalaryForDisplay(data) }}
      </p>
    </div>
    <a
      class="button button__width button--filled job-card__apply-button"
      href="https://infermedica.applytojob.com/apply"
      target="_blank"
    >
      <span class="button__content"> Apply </span>
    </a>
  </BaseCard>
</template>

<script lang="ts" setup>
import type { JobDataSummary } from '@/types'
import { formatSalaryForDisplay } from '@/utils/careers'

interface Props {
  data: JobDataSummary
}

const props = defineProps<Props>()

const location = computed(
  () => `Remote${props.data.country_id ? '/' + props.data.country_id : ''}`,
)
</script>

<style lang="scss" scoped>
.job-card {
  flex-direction: column;
  width: 100%;
  padding: 24px;

  &__name {
    margin-bottom: 32px;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid var(--gray-400);

    &:last-of-type {
      border-bottom: none;
      margin-bottom: 20px;
    }

    &--location {
      padding-right: 26px;
    }
  }

  &__label {
    margin-bottom: 0;
    font-size: var(--font-size-paragraph-s);
    font-weight: var(--font-weight-paragraph-bold);
    line-height: 26px;
  }

  &__value {
    margin-bottom: 0;
    font-size: var(--font-size-paragraph-s);
    line-height: 26px;
  }

  &__remote-value {
    margin-right: 20px;
  }

  &__apply-button {
    display: block;
    width: 100% !important;
  }

  &__tooltip {
    @include paragraph-xs;

    margin-bottom: 12px;
    color: var(--cobalt-800);

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__tooltip-location {
    @include paragraph-xs;

    margin-bottom: 12px;
    color: var(--cobalt-800);
    font-weight: 700;
  }

  &__icon {
    @include icon('@/assets/icons/info-fill.svg', 20px, 20px);

    background-size: auto;
    margin-left: 6px;
  }
}
</style>
